import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class DocumentTypeService {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getDocumentType(payload) {
    return this._http.get(this.baseUrl + '/document-type/', {
      params: payload.params,
    });
  }
  getDocumentUpload(payload) {
    return this._http.get(
      `${this.baseUrl}/object-document/${payload.optionId}`
    );
  }
  getSupportingDocumentUpload() {
    return this._http.get(`${this.baseUrl}/supporting-documents/types`);
  }
  getSupportingDocuments() {
    return this._http.get(`${this.baseUrl}/supporting-documents`);
  }
  addDocumentType(payload) {
    return this._http.post(this.baseUrl + '/document-type', payload.body);
  }

  updateDocumentType(payload) {
    return this._http.post(
      `${this.baseUrl}/document-type/${payload.id}`,
      payload.body
    );
  }

  deleteDocumentType(payload) {
    return this._http.delete(`${this.baseUrl}/document-type/${payload.id}`);
  }
}
